import React, { Component } from "react"
import styles from "../css/postlist.module.css"

export default class Social extends Component {
  render() {
    return (
      <div className={styles.social}>
        <a href="https://twitter.com/NaimulIslamSiam">
          Twitter
        </a>
        <a href="https://github.com/Naimul-Islam-Siam">
          GitHub
        </a>
        <a href="https://medium.com/@NaimulIslamSiam">
          Medium
        </a>
      </div>
    )
  }
}
